var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"frame",staticClass:"frame",style:(_vm.getFrameStyle),attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.selectedProjectIndex == -1),expression:"this.selectedProjectIndex == -1"}],style:({
      position: 'relative',
      top: '0px',
      zIndex: '1',
      height: this.getScreenHeight + 'px'
    })},[_vm._l((this.getConformedProjects),function(_project,index){return _c('div',{key:index,style:({position:'relative'})},[_c('ProjectSquare',{key:index,attrs:{"pSize":_vm.getSquareSize(_project.tSizeSquare),"pIndex":index,"pLocation":_vm.arrLocations[index],"pAtEnd":_vm.arrEnds[index],"pProject":_project,"pSelectedProjectIndex":-1,"tick":_vm.squareTick,"boxSize":_vm.boxSize,"gridMargin":_vm.gridMargin,"pSizeSquare":_project.tSizeSquare}})],1)}),_c('div',{style:({
        height: '40px',
        position: 'relative',
      })}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(this.isSlideshow),expression:"this.isSlideshow"}],style:({
        width: '100vw',
        height: '100vh',
        backgroundColor: '#000000cc',
        position: 'absolute',
        top: '0px',
        bottom: '0px',
        zIndex: '900'
      })},[_c('Slideshow')],1)],2),(this.selectedProjectIndex != -1)?_c('div',{staticClass:"projectPreviewFrame"},[_c('ProjectSquare',{attrs:{"pSize":_vm.getSquareSize(1),"pIndex":this.selectedProjectIndex,"pProject":this.getConformedProjects[this.selectedProjectIndex],"pSelectedProjectIndex":_vm.selectedProjectIndex}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }